import Manual from './Manual.vue'
import Terminal from './Terminal.vue'

Manual.guid = 'b0bca8b297674792a6f4489d272b8230-MANUAL'
Terminal.guid = 'b0bca8b297674792a6f4489d272b8230-TERMINAL'

export default {
  guid: 'b0bca8b297674792a6f4489d272b8230',
  components: [
    Terminal,
    Manual,
  ],
}
